<template>
  <nav aria-label="breadcrumb" class="breadcrumb-container">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link to="/">
          <font-awesome-icon icon="home" class="me-2" /> Inicio
        </router-link>
      </li>
      <li 
        v-for="(crumb, index) in breadcrumbs" 
        :key="index" 
        class="breadcrumb-item"
        :class="{ active: index === breadcrumbs.length - 1 }"
        :title="crumb.text" 
      >
        <!-- Tooltip para nombres largos -->
        <router-link v-if="index !== breadcrumbs.length - 1" :to="crumb.to">
          <font-awesome-icon icon="angle-right" class="me-1" /> {{ crumb.text }}
        </router-link>
        <span v-else>
          <font-awesome-icon icon="angle-right" class="me-1" /> {{ crumb.text }}
        </span>
      </li>
    </ol>
  </nav>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'ListaBreadcrumbs',
  components: {
    FontAwesomeIcon
  },
  computed: {
    breadcrumbs() {
      let currentRoute = this.$route;
      let breadcrumbs = [];
  
      currentRoute.matched.forEach((route) => {
        if (route.meta && route.meta.breadcrumb) {
          breadcrumbs.push({
            text: route.meta.breadcrumb,
            to: route.path,
          });
        }
      });
  
      return breadcrumbs;
    },
  },
};
</script>

<style scoped>
.breadcrumb-container {
  background-color: #fff;
  padding: 0.75rem 1rem;
  border: 1px solid #ced4da;
  border-radius: 15px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  margin-bottom: 1rem;
}

.breadcrumb {
  background-color: transparent;
  margin-bottom: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.breadcrumb-item {
  font-size: 1rem;
  color: var(--app-primary);
  transition: color 0.3s;
}

.breadcrumb-item.active {
  font-weight: bold;
  color: #495057;
}

.breadcrumb-item + .breadcrumb-item::before {
  content: '';
}

.breadcrumb a {
  text-decoration: none;
  color: inherit;
}

.breadcrumb a:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .breadcrumb {
    font-size: 0.9rem;
  }
}

.breadcrumb-item span {
  color: #495057;
}
</style>
